module.exports = __webpack_public_path__ + "img/br22.2b43e38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br22.jpg
// module id = 278B
// module chunks = 0